import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import { Dialog } from "~components/shared/Dialog/Dialog";
import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";

import { GEOLOCATION_POSITION_UNSUPPORTED } from "./createPositionError";

export interface PositionErrorModalProps {
  data: GeolocationPositionError | null;
  isModalOpen: boolean;
  onClose: () => void;
}

export function PositionErrorModal({
  data,
  isModalOpen,
  onClose,
}: PositionErrorModalProps) {
  const t = useTranslation();

  return (
    <Dialog
      icon={<DoDisturbIcon />}
      open={isModalOpen}
      dialogTitle={t.timeTrackingPositionErrorTitle}
    >
      {data && (
        <DialogContent>
          <ErrorComponent error={data} />
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={onClose}>{t.timeTrackingPositionModalConfirm}</Button>
      </DialogActions>
    </Dialog>
  );
}

type ErrorProps = {
  error: GeolocationPositionError;
};
function ErrorComponent({ error }: ErrorProps) {
  const t = useTranslation();

  const paragraphs: Partial<Record<number, [string, string]>> = {
    [error.PERMISSION_DENIED]: [
      t.timeTrackingPositionErrorContentParagraph1,
      t.timeTrackingPositionErrorContentParagraph2,
    ],
    [error.POSITION_UNAVAILABLE]: [
      t.timeTrackingPositionUnavailableErrorContentParagraph1,
      t.timeTrackingPositionRetryableErrorContentParagraph2,
    ],
    [error.TIMEOUT]: [
      t.timeTrackingPositionTimeoutErrorContentParagraph1,
      t.timeTrackingPositionRetryableErrorContentParagraph2,
    ],
    [GEOLOCATION_POSITION_UNSUPPORTED]: [
      t.timeTrackingPositionUnsupportedErrorContentParagraph1,
      t.timeTrackingPositionUnsupportedErrorContentParagraph2,
    ],
  };
  const [first, second] = paragraphs[error.code] ?? [
    t.timeTrackingPositionUnknownErrorContentParagraph1,
    t.timeTrackingPositionRetryableErrorContentParagraph2,
  ];

  return (
    <>
      <p>{first}</p>
      <p>{second}</p>
    </>
  );
}
